// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3090":"6e984cbb","6298":"0efacb78"}[chunkId] + ".chunk.css";
};